import { useState } from "react";
import Add from './addquestion';
import Add1 from './addillness';

// Composant EditableBlockList
const EditableBlockList = () => {
  const [isOpen, setIsOpen] = useState(false); // Etat pour gérer l'ouverture/fermeture du dropdown

  const toggleDropdown = () => {
    setIsOpen(!isOpen); // Change l'état d'affichage
  };

  return (
    <div>
      <div className="position-relative">
        <p 
          className="py-3 fw-bold text-center" 
          style={{background:'#FFF6E8',borderRadius:'15px'}}
          onClick={toggleDropdown} // Ajout du clic pour basculer l'état
        >
          Medical prescriptions
        </p>
        <i 
          className="bi bi-caret-down-fill pos1" 
          style={{color:'#FF9800'}}
        ></i>
      </div>

      {isOpen && ( // Affiche le contenu seulement si isOpen est vrai
        <div className="mb-4 mt-3 p-3" style={{ border: '1px dashed #FF9800', borderRadius: '10px',margin:'0px 40px' }}>

        <ol>
          <li>Medications:
            <ul>
              <li>Aspirin: 200 mg daily</li>
              <li>Ibuprofen: 200 mg daily</li>
              <li>Dextromethorphan: 5 mg daily</li>
            </ul>
          </li>
          <li>Laboratory Tests:
            <ul>
              <li>Urinalysis: To confirm the presence of infection and determine the severity.</li>
              <li>Urine Culture and Sensitivity Test: To identify the specific bacteria causing the infection and determine the appropriate antibiotic.</li>
              <li>Complete Blood Count (CBC): To check for signs of systemic infection or inflammation.</li>
            </ul>
          </li>
          <li>Non-Pharmacological Recommendations:
            <ul>
              <li>Increase fluid intake to at least 2 liters per day to help flush out the urinary tract.</li>
              <li>Avoid caffeine, alcohol, and spicy foods, which can irritate the bladder.</li>
            </ul>
          </li>
          <li>Follow-Up:
            <ul>
              <li>Schedule a follow-up appointment in 10 days to review test results and assess treatment progress.</li>
            </ul>
          </li>
        </ol>
      </div>
      )}
    </div>
  );
};

export default EditableBlockList;
